import React, { Component } from 'react';
import axios from 'axios';
import $ from 'jquery';

import LoadingScreen from '../../Ui/LoadingScreen/LoadingScreen';

import classes from './InternalFunctions.module.css';
import { pushToError } from '../../../utils/common';
class InternalFunctions extends Component {
  state = {
    htmlApiLoading: true,
  };
  componentDidMount() {
    console.log("this.props.settings.token", this.props.settings.token)
    this.props.setCurrentRouteState('if', 'Internal Functions');
    if (!this.props.userfleetApiLoading) {
      $('.' + classes.InternalFunctions).load(
        '/html/angularContainer.html',
        () => {
          const url = `${this.props.settings.server}pi/pi.admin/pi.static/html/internalpage.html`;
          axios
            .get(url, {
              headers: { Authorization: `Bearer ${this.props.settings.token}` },
            })
            .then((response) => {
              $('#angularContainer').load(window.makeTextFile(response.data));
              this.setState({
                htmlApiLoading: false,
              });
            })
            .catch((err) => {
              console.error(err);
              pushToError(this.props,this.state.pname,err,url);
            });
        }
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userfleetApiLoading !== this.props.userfleetApiLoading) {
      this.setState({
        htmlApiLoading: true,
      });
      $('.' + classes.InternalFunctions).load(
        '/html/angularContainer.html',
        () => {
          const url = `${this.props.settings.server}pi/pi.admin/pi.static/html/internalpage.html`;
          axios
            .get(url, {
              headers: { Authorization: `Bearer ${this.props.settings.token}` },
            })
            .then((response) => {
              $('#angularContainer').load(window.makeTextFile(response.data));
              this.setState({
                htmlApiLoading: false,
              });
            })
            .catch((err) => {
              console.error(err);
              pushToError(this.props,this.state.pname,err,url);
            });
        }
      );
    }
  }
  render() {
    return (
      <React.Fragment>
        {this.state.htmlApiLoading || this.props.userfleetApiLoading ? (
          <LoadingScreen />
        ) : null}
        <div className={classes.InternalFunctions}></div>
      </React.Fragment>
    );
  }
}

export default InternalFunctions;
